import { ApiProperty } from "@nestjs/swagger";

export class StockInRequestDto {
    @ApiProperty()
    month: number;
    @ApiProperty()
    year: number;
    @ApiProperty()
    unitId: string;

    @ApiProperty()
    reportType: string;
}
